import {basicVars} from "../utils/helpers/constants";

let delay = (fn, ms) => new Promise((resolve) => setTimeout(() => {
    fn()
    resolve()
}, ms))

async function toggleElement(el, show) {
    const hidden = basicVars.hidden
    const shown = basicVars.shown

    if(show) {
        el.classList.remove(hidden)
        await delay(() => el.classList.add(shown), 100)
    } else {
        el.classList.remove(shown)
        await delay(() => el.classList.add(hidden), 300)
    }
}


const searchForm = () => {
    const toggler = document.querySelector('.header-search');
    const searchMenu = document.querySelector('.search-block-nav-menu');

    if (!toggler || !searchMenu) return;

    function toggleSearchForm(e) {
        const button = e.currentTarget;
        const shown = searchMenu.classList.contains('shown');

        button.classList.toggle('opened');
        toggleElement(searchMenu, !shown);
    }

    toggler.addEventListener('click', toggleSearchForm);

    window.addEventListener('resize', function(e) {
        const width = e.currentTarget.innerWidth;
        if(width <= 768) {
            toggleElement(searchMenu, false);
            toggler.classList.remove('opened');
        }
    })

}

export default searchForm;